import { apiClient } from './apiClient';
import { authService } from './authService';

const getCompanyParam = () => {
  const companyId = authService.getCompanyId();
  return companyId ? `companyId=${companyId}` : '';
};

export const contractService = {
  // Get all contracts
  async getContracts() {
    return apiClient.get(`/api/cmms/contracts?${getCompanyParam()}`);
  },

  // Get contracts by status
  async getContractsByStatus(status) {
    return apiClient.get(`/api/cmms/contracts/status/${status}?${getCompanyParam()}`);
  },

  // Get contracts by supplier
  async getContractsBySupplier(supplierId) {
    return apiClient.get(`/api/cmms/contracts/supplier/${supplierId}?${getCompanyParam()}`);
  },

  // Get active contracts
  async getActiveContracts() {
    return apiClient.get(`/api/cmms/contracts/active?${getCompanyParam()}`);
  },

  // Get expiring contracts
  async getExpiringContracts(daysAhead = 30) {
    return apiClient.get(`/api/cmms/contracts/expiring?${getCompanyParam()}&daysAhead=${daysAhead}`);
  },

  // Get single contract by ID
  async getContractById(id) {
    return apiClient.get(`/api/cmms/contracts/${id}?${getCompanyParam()}`);
  },

  // Create new contract
  async createContract(data) {
    return apiClient.post(`/api/cmms/contracts?${getCompanyParam()}`, data);
  },

  // Update contract
  async updateContract(id, data) {
    return apiClient.put(`/api/cmms/contracts/${id}?${getCompanyParam()}`, data);
  },

  // Delete contract
  async deleteContract(id) {
    return apiClient.delete(`/api/cmms/contracts/${id}?${getCompanyParam()}`);
  },

  // Add assets to contract
  async addAssets(contractId, assetIds, notes = null) {
    return apiClient.post(`/api/cmms/contracts/${contractId}/assets?${getCompanyParam()}`, {
      assetIds,
      notes,
    });
  },

  // Remove asset from contract
  async removeAsset(contractId, assetId) {
    return apiClient.delete(`/api/cmms/contracts/${contractId}/assets/${assetId}?${getCompanyParam()}`);
  },

  // Get contract files
  async getContractFiles(contractId) {
    return apiClient.get(`/api/cmms/contracts/${contractId}/files?${getCompanyParam()}`);
  },

  // Upload file to contract
  async uploadFile(contractId, file, description = null, uploadedBy = null) {
    const formData = new FormData();
    formData.append('file', file);
    if (description) formData.append('description', description);
    if (uploadedBy) formData.append('uploadedBy', uploadedBy);

    return apiClient.upload(`/api/cmms/contracts/${contractId}/files?${getCompanyParam()}`, formData);
  },

  // Delete file from contract
  async deleteFile(contractId, fileId) {
    return apiClient.delete(`/api/cmms/contracts/${contractId}/files/${fileId}?${getCompanyParam()}`);
  },
};
